export default __webpack_public_path__ + "static/media/Broadform-Homeowners-Key-Information-Document-1-April-2023.fa8f91b2.pdf";